// src/components/LegalDisclaimer.js (NUEVO COMPONENTE)

import React from 'react';
import './LegalDisclaimer.css';
import { FaExclamationTriangle } from 'react-icons/fa'; // Icono de advertencia

const LegalDisclaimer = () => {
    return (
        <section id="legal-disclaimer-section">
            <div className="disclaimer-content">
                <FaExclamationTriangle className="disclaimer-icon" />
                <p className="disclaimer-text">
                    <strong>¡Advertencia Legal Importante!</strong> Soy Consultor Legal Internacional certificado en **Venezuela**. Mis servicios están **exclusivamente disponibles en Venezuela** y se limitan a la legislación venezolana. No estoy autorizado para ejercer la abogacía en Estados Unidos ni para asesorar sobre las leyes de Estados Unidos. Esta página web tiene **fines meramente informativos** y no establece ninguna relación profesional en Estados Unidos.
                </p>
            </div>
        </section>
    );
};

export default LegalDisclaimer;